import * as React from "react";
import {
  TextField,
  ToggleButtonGroup,
  ToggleButton,
  Stack,
  Typography,
  Autocomplete,
} from "@mui/material";
// import NumberField from "../../components/NumberField";
import { MobileDatePicker } from "@mui/x-date-pickers";

export const ListaPropiedades = (props) => {
  const {
    opciones,
    propiedades,
    respuestas,
    setRespuestas,
    mostrarError,
    // label,
  } = props;

  const handleFocus = (e) => {
    const inputActivo = e.target;

    setTimeout(() => {
      inputActivo.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }, 300);
  };

  return (
    <Stack spacing={1.2} sx={{ pl: 2 }}>
      {propiedades &&
        propiedades.map((p, index) => (
          <Stack direction="column" spacing={0.2} key={"p" + p.id}>
            <Stack direction="row" spacing={0.2} sx={{ alignItems: "center" }}>
              <Typography sx={{ fontWeight: p.requerido && "bold" }}>
                {p.descripcion}
              </Typography>
              {!p.requerido && (
                <Typography sx={{ fontSize: "small", fontStyle: "italic" }}>
                  {" [opcional]"}
                </Typography>
              )}
            </Stack>

            <Stack sx={{ ml: 4, mr: 2 }}>
              {p.tipo === 1 ? (
                <TextField
                  type="number"
                  error={mostrarError && p.requerido && !respuestas[p.id]}
                  value={respuestas[p.id] || ""}
                  onFocus={(e) => {
                    typeof e.target.select === "function" && e.target.select();
                    handleFocus(e);
                  }}
                  data-invalid={p.requerido && !respuestas[p.id]}
                  onChange={(e) =>
                    setRespuestas({
                      ...respuestas,
                      [p.id]: e.target.value.toUpperCase(),
                    })
                  }
                />
              ) : p.tipo === 2 ? (
                <TextField
                  error={mostrarError && p.requerido && !respuestas[p.id]}
                  value={respuestas[p.id] || ""}
                  onFocus={(e) => {
                    typeof e.target.select === "function" && e.target.select();
                    handleFocus(e);
                  }}
                  data-invalid={p.requerido && !respuestas[p.id]}
                  onChange={(e) =>
                    setRespuestas({
                      ...respuestas,
                      [p.id]: e.target.value.toUpperCase(),
                    })
                  }
                />
              ) : p.tipo === 3 ? (
                <TextField
                  error={mostrarError && p.requerido && !respuestas[p.id]}
                  multiline
                  rows={4}
                  placeholder={p.placeholder}
                  data-invalid={p.requerido && !respuestas[p.id]}
                  value={respuestas[p.id] || ""}
                  onFocus={(e) => {
                    typeof e.target.select === "function" && e.target.select();
                    handleFocus(e);
                  }}
                  onChange={(e) =>
                    setRespuestas({
                      ...respuestas,
                      [p.id]: e.target.value,
                    })
                  }
                />
              ) : p.tipo === 4 ? (
                <Autocomplete
                  slotProps={{
                    textField: {
                      size: "small",
                      margin: "dense",
                      fullWidth: true,
                      onFocus: handleFocus,
                    },
                  }}
                  data-invalid={p.requerido && !respuestas[p.id]}
                  options={opciones.map(
                    (o) =>
                      p.lista_opciones?.split(",").includes(o.id.toString()) &&
                      o,
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      size="small"
                      error={mostrarError && p.requerido && !respuestas[p.id]}
                      margin="dense"
                      fullWidth
                    />
                  )}
                  value={respuestas[p.id]}
                  getOptionLabel={(option) => option?.opcion || ""}
                  onChange={(e) =>
                    setRespuestas({ ...respuestas, [p.id]: e.target.value })
                  }
                />
              ) : p.tipo === 5 ? (
                <MobileDatePicker
                  slotProps={{
                    textField: {
                      size: "small",
                      margin: "dense",
                      fullWidth: true,
                      error: mostrarError && p.requerido && !respuestas[p.id],
                      onFocus: handleFocus,
                    },
                  }}
                  localeText={{
                    cancelButtonLabel: "Cancelar",
                    toolbarTitle: (
                      <Stack
                        direction="row"
                        spacing={0.2}
                        sx={{ alignItems: "center" }}
                      >
                        <Typography sx={{ fontWeight: p.requerido && "bold" }}>
                          {p.descripcion}
                        </Typography>
                        {!p.requerido && (
                          <Typography
                            sx={{ fontSize: "small", fontStyle: "italic" }}
                          >
                            {" [opcional]"}
                          </Typography>
                        )}
                      </Stack>
                    ),
                  }}
                  data-invalid={p.requerido && !respuestas[p.id]}
                  value={respuestas[p.id] || null}
                  onChange={(e) => {
                    setRespuestas({ ...respuestas, [p.id]: e });
                  }}
                />
              ) : (
                <ToggleButtonGroup
                  fullWidth
                  exclusive
                  data-invalid={p.requerido && !respuestas[p.id]}
                  sx={{
                    "& .MuiToggleButtonGroup-grouped": {
                      borderColor:
                        mostrarError &&
                        p.requerido &&
                        !respuestas[p.id] &&
                        "error.main",
                    },
                  }}
                  onFocus={handleFocus}
                  value={respuestas[p.id]}
                  onChange={(e, v) => {
                    if (Boolean(v)) {
                      setRespuestas({ ...respuestas, [p.id]: v });
                      // } else {
                      //   delete respuestas[p.id];
                    }
                  }}
                >
                  {opciones.map(
                    (o) =>
                      p.lista_opciones.split(",").includes(o.id.toString()) && (
                        <ToggleButton color="primary" value={o.id}>
                          {o.opcion}
                        </ToggleButton>
                      ),
                  )}
                </ToggleButtonGroup>
              )}
            </Stack>
          </Stack>
        ))}
    </Stack>
  );
};
export default ListaPropiedades;
